import { Page } from "components/page/page.component";
import { Text } from "components/text/text.component";
import unauthorizedImage from 'assets/images/door-lock.png'
import unauthorizedImageDark from 'assets/images/door-lock-dark.png'
import style from './forbidden.page.module.css'
import { View } from "components/view/view.component";
import { Image } from "components/image/image.component";
import { useEffect, useState } from "react";

export function ForbiddenPage(){
    const initialIsDarkMode = window.matchMedia && window.matchMedia('(prefers-color-scheme: dark)').matches
    const [isDarkMode, setIsDarkMode] = useState(initialIsDarkMode)
    useEffect(() => {
            const mediaQuery = window.matchMedia('(prefers-color-scheme: dark)');
        
            const handleChange = (event: { matches: boolean | ((prevState: boolean) => boolean) }) => {
              setIsDarkMode(event.matches);
            };
        
            mediaQuery.addEventListener('change', handleChange);
        
            // Cleanup function
            return () => {
              mediaQuery.removeEventListener('change', handleChange);
            };
          }, []);
    return <Page menu header className={style.Page}>
        <View className={style.PageContent}>
            <Image src={isDarkMode? unauthorizedImageDark : unauthorizedImage} alt="" width={'400px'}/>
            <Text type="h1" >Acesso não autorizado</Text>
            <Text type="md" subtext>Você não está autorizado a acessar esta página.<br/>Para mais informações, entre em contato com o administrador do sistema responsável pela sua empresa ou com a equipe da AROTech através do email admin@arotech.app.</Text>
        </View>
    </Page>
}